export const getCookieConsent = (cookieJar) => {
  const regex = /CookieControl=(.[^;]*)/gi;
  const match = regex.exec(cookieJar);

  if (match) {
    try {
      const consentObj = JSON.parse(match[1]);

      return consentObj?.optionalCookies?.analytics === "accepted";
    } catch {
      return false;
    }
  }

  return false;
};
